export const companyMock = {
    company: {
        companiesAndCompaniesAccounts: {
            loadState: 'success',
            data: [
                {
                    id: 14,
                    name: 'Team test - 13',
                    logo: null,
                    type_id: 9,
                    type: 'client',
                    company_name: 'Team test',
                    shared: false,
                    accounts: [
                        {
                            id: 38,
                            name: 'Facebook Ads Account Example  13',
                            ad_account: {
                                id: 13,
                                type: 'facebook_ads',
                                type_id: 2,
                                account_id: '999999999',
                            },
                            type_id: 8,
                            type: 'account',
                        },
                    ],
                },
                {
                    id: 2,
                    name: 'Team test 2',
                    logo: null,
                    type_id: 9,
                    type: 'client',
                    company_name: 'Team test 2',
                    shared: true,
                    accounts: [
                        {
                            id: 4,
                            name: 'Google Ads Account Example 2',
                            ad_account: {
                                id: 2,
                                customer_id: '999999999',
                                type: 'google_ads',
                                type_id: 1,
                            },
                            type_id: 8,
                            type: 'account',
                        },
                        {
                            id: 5,
                            name: 'Facebook Ads Account Example 2',
                            ad_account: {
                                id: 2,
                                type: 'facebook_ads',
                                type_id: 2,
                                account_id: '999999999',
                            },
                            type_id: 8,
                            type: 'account',
                        },
                    ],
                },
            ],
            error: null,
        },
    },
};
